import React from 'react';

interface IconMenuProps {
    iconClasses?: string;
}

const IconMenu: React.FC<IconMenuProps> = ({ iconClasses }) => {
    return (
        <svg
            width="15"
            height="15"
            viewBox="0 0 15 15"
            className={`icon icon-menu ${iconClasses ?? ''}`}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden="true"
        >
            <path
                d="M12.5 2.5H2.5C2.15482 2.5 1.875 2.77982 1.875 3.125V4.375C1.875 4.72018 2.15482 5 2.5 5H12.5C12.8452 5 13.125 4.72018 13.125 4.375V3.125C13.125 2.77982 12.8452 2.5 12.5 2.5Z"
                stroke="#6B7787"
                strokeWidth="1.1875"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M12.5 6.25H2.5C2.15482 6.25 1.875 6.52982 1.875 6.875V8.125C1.875 8.47018 2.15482 8.75 2.5 8.75H12.5C12.8452 8.75 13.125 8.47018 13.125 8.125V6.875C13.125 6.52982 12.8452 6.25 12.5 6.25Z"
                stroke="#6B7787"
                strokeWidth="1.1875"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M12.5 10H2.5C2.15482 10 1.875 10.2798 1.875 10.625V11.875C1.875 12.2202 2.15482 12.5 2.5 12.5H12.5C12.8452 12.5 13.125 12.2202 13.125 11.875V10.625C13.125 10.2798 12.8452 10 12.5 10Z"
                stroke="#6B7787"
                strokeWidth="1.1875"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export default IconMenu;
